export default "__VITE_ASSET__BZyNu8Ve__"